<script setup>
import Icon from '@/Components/Icons/Icon.vue';

defineProps({
  size: {
    type: Number,
    default: 24
  },
  fill: {
    type: String,
    default: 'currentColor'
  }
});
</script>

<template>
  <Icon
    :size="size"
    :fill="fill"
    d="M120-240v-80h720v80H120Zm0-200v-80h720v80H120Zm0-200v-80h720v80H120Z"
  />
</template>
